module.exports = __webpack_public_path__ + "img/1517306356.a74601ce.jpg";